export default __webpack_public_path__ + "static/media/pc6.92032c96.jpg";